var MuiTypography = {
  styleOverrides: {
    root: {
      '&.MuiTypography-root': {
        fontFamily: 'cerapro'
      }
    }
  }
};
export default {
  MuiTypography: MuiTypography
};